var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFurniture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50 25.6458V32.0572H0V25.6458C0 23.9454 0.65848 22.3146 1.83058 21.1123C3.00269 19.9099 4.5924 19.2344 6.25 19.2344H43.75C45.4076 19.2344 46.9973 19.9099 48.1694 21.1123C49.3415 22.3146 50 23.9454 50 25.6458Z",
    fill: "#828284"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.0571V43.2771C0 43.7022 0.16462 44.1098 0.457646 44.4105C0.750671 44.7111 1.1481 44.8799 1.5625 44.8799H4.6875C5.1019 44.8799 5.49933 44.7111 5.79235 44.4105C6.08538 44.1098 6.25 43.7022 6.25 43.2771V38.4685H43.75V43.2771C43.75 43.7022 43.9146 44.1098 44.2076 44.4105C44.5007 44.7111 44.8981 44.8799 45.3125 44.8799H48.4375C48.8519 44.8799 49.2493 44.7111 49.5424 44.4105C49.8354 44.1098 50 43.7022 50 43.2771V32.0571H0ZM6.25 19.2342V12.8228C6.25 11.9726 6.57924 11.1572 7.16529 10.5561C7.75134 9.95487 8.5462 9.61712 9.375 9.61712H20.3125C21.1413 9.61712 21.9362 9.95487 22.5222 10.5561C23.1083 11.1572 23.4375 11.9726 23.4375 12.8228V19.2342H26.5625V12.8228C26.5625 11.9726 26.8917 11.1572 27.4778 10.5561C28.0638 9.95487 28.8587 9.61712 29.6875 9.61712H40.625C41.4538 9.61712 42.2487 9.95487 42.8347 10.5561C43.4208 11.1572 43.75 11.9726 43.75 12.8228V19.2342C44.8483 19.2545 45.9236 19.5606 46.875 20.1238V3.20571C46.875 2.3555 46.5458 1.54011 45.9597 0.93893C45.3737 0.337743 44.5788 0 43.75 0H6.25C5.4212 0 4.62634 0.337743 4.04029 0.93893C3.45424 1.54011 3.125 2.3555 3.125 3.20571V20.1238C4.07658 19.561 5.15176 19.255 6.25 19.2342Z",
    fill: "#828284"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture);
export default __webpack_public_path__ + "static/media/furniture.ee90cde4c803577f04494809d1e92aba.svg";
export { ForwardRef as ReactComponent };